export const ENROLLED_TOOLTIP =
  'A stakeholder is enrolled once you have shared your goals with them and asked for their input and ongoing support.'
